export enum BottomBannerTypes {
  OUT_OF_PAGE = 'OUT_OF_PAGE',
  SIDEBAR = 'SIDEBAR',
}
